import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { CustomLoginComponent } from './custom-login/custom-login.component';
import { AdminLoginComponent } from './features/components/admin-login/admin-login.component';
import { LoginUnicoTestComponent } from './features/components/login-unico-test/login-unico-test.component';
import { PoliciesComponent } from './policies/policies.component';

/**
 *  This file is used to add new routes for the app module.
 *  This file will not be deleted or overwritten by Palmyra Generator
 */
export const appRoutes: Routes = [
  { path: 'login-unico', component: LoginUnicoTestComponent },
  { path: 'policies', component: PoliciesComponent },
  { path: 'admin', component: AdminLoginComponent },
  {
    path: '',
    loadChildren: () => import('@app/home/home.module').then((m) => m.MainModule),
    canActivate: [MsalGuard]
  },
];
